import { DataPropertyType } from "../enums/data-property-type";

const DataPropertyMapping = [];
DataPropertyMapping["13"] = DataPropertyType.Sales;
DataPropertyMapping["15"] = DataPropertyType.Product

export default DataPropertyMapping;